import React, { useState } from "react";
import { Button, Icon, Confirm, Popup } from "semantic-ui-react";
import { Syllabu } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./SyllabuSubjectGradeItem.scss";

const syllabuController = new Syllabu();

export function SyllabuSubjectGradeItem(props) {
  const { syllabuSubjectGrade, onReload } = props;
  const { accessToken } = useAuth();

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openDeleteConfirm = () => {
    setConfirmMessage(
      `¿Eliminar la relación "${syllabuSubjectGrade.Grade?.name} - ${syllabuSubjectGrade.subject?.name}" de la malla curricular?`
    );
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await syllabuController.deleteSyllabuSubjectGrade(
        accessToken,
        syllabuSubjectGrade.id
      );
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="syllaby-subject-grade-item">
        <div className="syllaby-subject-grade-item__info">
          <span className="syllaby-subject-grade-item__info-grade">
            {syllabuSubjectGrade?.Grade?.name}
          </span>
        </div>
        <div className="syllaby-subject-grade-item__info">
          <span className="syllaby-subject-grade-item__info-subject">
            {syllabuSubjectGrade?.subject?.name}
          </span>
        </div>
        <Popup
          content="Eliminar asignatura"
          trigger={
            <Button icon color="red" onClick={openDeleteConfirm}>
              <Icon name="trash" />
            </Button>
          }
        />
      </div>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
